import { StudioUser } from "~/api/userApi";

export const getUserFullName = (user: StudioUser) => {
  // if (user.fullName) {
  //   return user.fullName;
  // }

  // Construct from "firstName lastName"
  if (user.firstName) {
    if (user.lastName) {
      return `${user.firstName} ${user.lastName}`;
    }
    return user.firstName;
  } else if (user.lastName) {
    return user.lastName;
  }

  return "";
};
